$(document).ready(function () {

  var better_slide = new Swiper(".better_slide .swiper-container", {
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    loop: true,
    spaceBetween: 16,
    centeredSlides: true,
    observer: true,
    observeParents: true,
    loopAdditionalSlides: 1,
    loopedSlides: 2,
    slidesPerView: 1.2,
    watchSlidesProgress: true,
    preloadImages: false,
    lazy: false,
    navigation: {
      nextEl: '.better_slide .swiper-button-next',
      prevEl: '.better_slide .swiper-button-prev',
    },
    breakpoints: {
      1280: { slidesPerView: 5.5 },
      1200: { slidesPerView: 5.5 },
      580:  { slidesPerView: 3   },
    },
    on: {
      init: function () {
        loadVideoAtIndex(this, this.activeIndex - 1);
        loadVideoAtIndex(this, this.activeIndex);
        loadVideoAtIndex(this, this.activeIndex + 1);
        playActiveSlideVideo(this);
      },
      slideChange: function () {
        loadVideoAtIndex(this, this.activeIndex);
        loadVideoAtIndex(this, this.activeIndex + 1);
        playActiveSlideVideo(this);
      },
    },
  });

  // Swiper 초기화 이후에 Observer 등록
  // 단, 복제 슬라이드(swiper-slide-duplicate)는 제외하고 원본만 관찰
  const lazyVideos = document.querySelectorAll(
    '.better_slide .swiper-slide:not(.swiper-slide-duplicate) video.lazy-video'
  );

  const videoObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;

      const video = entry.target;
      const source = video.querySelector('source[data-src]');

      if (source && !source.getAttribute('src')) {
        source.setAttribute('src', source.dataset.src);
        video.load();
      }

      videoObserver.unobserve(video);
    });
  }, {
    rootMargin: '200px',
  });

  lazyVideos.forEach(function (video) {
    videoObserver.observe(video);
  });

  function loadVideoAtIndex(swiper, index) {
    const slide = swiper.slides[index];
    if (!slide) return;
    const video = slide.querySelector('video.lazy-video');
    if (!video) return;
    const source = video.querySelector('source[data-src]');
    if (source && !source.getAttribute('src')) {
      source.setAttribute('src', source.dataset.src);
      video.load();
    }
  }

  function playActiveSlideVideo(swiper) {
    swiper.slides.forEach(function (slide) {
      const video = slide.querySelector('video');
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    });

    const activeSlide = swiper.slides[swiper.activeIndex];
    const activeVideo = activeSlide ? activeSlide.querySelector('video') : null;
    if (activeVideo) {
      activeVideo.play().catch(function () {});
    }
  }

});